import React, { Suspense, useState } from 'react'
import { useAppDispatch, useAppSelector, useUserPermissions } from 'app/hooks'
import { FloorplanList } from './FloorplanList'
import { FloorplanView } from './FloorplanView'
import { PageType, UserRole, PromptType } from 'app/types'
import { BuildingPage } from 'views/BuildingPage/BuildingPage'
const Spin = React.lazy(() => import('components/Spin/Spin'))
import * as fnc from 'helpers/fnc'
import { Spinner } from 'components'
import { toggleFullscreen, showPrompt } from 'actions/appActions'


interface FloorplanPageProps {
    app: AppData,
    onlyFavourites: boolean,
    dataLink: string,
    splitIndex: number,
    breadCrumbs?: boolean,
}
export function FloorplanPage(props: FloorplanPageProps) {
    const { app, pageLink, dataLink, extraLink, splitIndex, onlyFavourites } = props
    const userPermissions = useUserPermissions()
    const dispatch = useAppDispatch()
    const screen = useAppSelector((state: RootState) => state.app.screen)
    const media = useAppSelector((state: RootState) => state.app.media)
    const [showSpin, setShowSpin] = useState(null)

    function handleTour(tourMediaId: string) {
        console.log('FloorplanPage handleTour called with tourMediaId:', tourMediaId)
        
        if (!tourMediaId) {
            console.error('No tourMediaId provided')
            return
        }
        
        const tourMedia = media[tourMediaId]
        console.log('Found tourMedia:', tourMedia)
        
        if (tourMedia) {
            console.log('Dispatching showPrompt with media:', tourMedia)
            dispatch(showPrompt({ 
                type: PromptType.Lightbox, 
                app: app, 
                media: [tourMedia], 
                mediaOptions: { autoplay: 1, focus: true } 
            }))
        } else {
            console.error('No tourMedia found for tourMediaId:', tourMediaId)
        }
    }
    
    function handleSpin(x) {
        setShowSpin(x)
    }

    function handleFullscreen(x) {
        if (screen.fullscreenSupport) {
            fnc.toggleFullscreen(x)
        } else {
            dispatch(toggleFullscreen())
        }
    }

    // Only render spin if its published
    const spin = app.spins.find((x) => x.link == 'site')
    if (spin != null && (spin.published || userPermissions(UserRole.ProjectEdit)) && !onlyFavourites) {
        return <BuildingPage pageType={PageType.Floorplan} {...props} />
    }

    if (showSpin) {
        const spin = app.spins.find((x) => x.id == showSpin)
        if (spin) {
            return <Suspense fallback={<Spinner overlay invert />}>
                <Spin
                    app={app}
                    spinLink={spin.link}
                    viewLink={spin.views[0].link}
                    splitIndex={null}
                    // focusSet={focusSet}
                    // splitView={true}
                    // filteredUnits={filteredUnits}
                    pageType={PageType.Floorplan}
                    onFullscreen={handleFullscreen}
                    disclaimer={true}
                    onClose={() => setShowSpin(null)}/>
            </Suspense>
        }
    }
    
    if (props.dataLink) {
        return <FloorplanView key={0} onTour={handleTour} onSpin={handleSpin} {...props} />
    }
    return <FloorplanList key={0} onTour={handleTour} onSpin={handleSpin} {...props} />
}
